import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import egam from "../../services/egam";
import { getClientData } from "../../services/auth";
import { queryKeys } from "../api/queryKeys";
import { PrazoMedioParams, PrazoMedioResponse } from "../../types/Parcelamento";

export const usePrazoMedio = (
  params: PrazoMedioParams | null,
  enabled: boolean = true
) => {
  return useQuery<PrazoMedioResponse>({
    queryKey: queryKeys.prazoMedio(params),
    queryFn: async () => {
      if (!params || !params.parcela || !params.intervalo) {
        throw new Error("Parâmetros não fornecidos");
      }

      const clientData = getClientData();
      if (!clientData) {
        throw new Error("Cliente não autenticado");
      }

      const formData = new FormData();
      formData.append("pedidoExterno", "true");
      formData.append("totalLiquido", params.totalLiquido.toFixed(2));
      formData.append("totalMedicamentos", params.totalMedicamentos.toFixed(2));
      formData.append("totalPerfumaria", params.totalPerfumaria.toFixed(2));
      formData.append("NR_PARCELAS", params.parcela);
      formData.append("QT_DIAS_INTERVALO", params.intervalo);

      const response = await egam.post<PrazoMedioResponse>(
        "pedidos/finalizar/parcelamento/intervalo",
        formData
      );

      if (response.data && response.data.msg_err) {
        const errorMsg = String(response.data.msg_err);
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }

      return response.data;
    },
    enabled:
      enabled &&
      params !== null &&
      params.parcela !== "" &&
      params.intervalo !== "",
    staleTime: 0, // Sempre refetch quando os parâmetros mudarem
    refetchOnMount: "always", // Sempre refetch quando o componente montar
  });
};
